module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "fmh"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication#ded",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("Animal Control")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("No Friends’ Pets")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Horns and Hair")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Side Effects")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dog Attack")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Llama Mayhem")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not Thinking")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baby-Sitter")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nurse Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Woman’s Best Friend")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elvis")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alpaca Down")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maternity Ward")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Makes a Vet")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not Dog Food")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christmas Mule")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Personality Disorder")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stay Off the Internet")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Then There Were Three")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Want Me to Do What?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Attorney Cat")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Surprise")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Won’t Bite")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unicorn")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adcd",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Jeff Wells")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor#author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0